import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px 20px 32px;
  background: ${(props) => props.theme.mainBackgorund};
  border-bottom: 1px solid ${(props) => props.theme.dividerMainColor};
`;

export const Title = styled.h1`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;